function Header() {
	return (
		<section className='bg-white py-20 sm:py-24'>
			<div className='container mx-auto max-w-7xl px-4 lg:px-6'>
				<div className='text-center'>
					<h2 className='text-4xl font-extrabold tracking-tighter text-gray-900 sm:text-5xl'>
						My mission
					</h2>
				</div>
			</div>
		</section>
	);
}

export default function MissionStatement() {
	return (
		<main className='bg-white py-10 sm:py-12'>
			<Header />
			<div className='container mx-auto max-w-7xl px-4 lg:px-6'>
				<section className='mt-10'>
					<h3 className='text-2xl font-semibold text-gray-900'>What I do</h3>
					<p className='mt-4 text-lg leading-7 text-gray-600'>
						I provide personal, transparent solar guidance to homeowners and
						businesses across the Mid-Atlantic — Maryland, Pennsylvania,
						Virginia, and Washington DC. My goal is to reshape the way you think
						about energy. Going solar offers real benefits in both the short and
						long term: lower energy costs, a smaller carbon footprint, and
						increased property value.
					</p>
					<p className='mt-4 text-lg leading-7 text-gray-600'>
						Whether you’re a homeowner tired of unpredictable price hikes from
						the utility company, or a business leader looking to control costs,
						solar is worth a serious look. I focus on clear, reliable solutions
						that produce clean energy, reduce costs, give back control, and
						benefit the environment — and I tell you straight when it makes
						sense and when it doesn’t.
					</p>
				</section>
			</div>
		</main>
	);
}
